import { useState } from 'react';
import { Form, Container, Button } from 'react-bootstrap';
import * as CustomerApi from '../Services/CustomerApi';

export default function Login({setToken}) {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [showError, setShowError] = useState();


    async function loginUser(credentials) {
        setShowError()
        const response =  await CustomerApi.getAuthToken(username, password);
        if (!response || !response.token) {
            // throw new Error('Invalid token sent from CustomerAPI auth.')
            setShowError('Invalid Login');
        }
        setToken(response.token);
    }



    return (
        <Container fluid style={{margin: 'auto', width: '400px', height: 'auto', border:'0px', backgroundColor : '#fff', borderRadius:'5px', padding: '40px 20px', boxShadow: '0 2px 40px 0 rgba(127, 136, 155, 0.18)'}}>
            <center><h1>AmazingCo UserHQ</h1></center>
            <h2 hidden={!showError} style={{color: '#f00'}}>
                    {showError}
            </h2>

            <Form>
                <Form.Group className="mb-3" controlId="formBasicEmail" value={username} onChange={(e) => setUsername(e.target.value)}>
                    <Form.Label>Email address</Form.Label>
                    <Form.Control type="email" placeholder="Enter email" />
                </Form.Group>

                <Form.Group className="mb-3" controlId="formBasicPassword">
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} />
                </Form.Group>
                <Button variant="primary" type="button" onClick={() => loginUser()}>
                    Submit
                </Button>
            </Form>
        </Container>

    )
}